var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHowToGuide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.825 22.002",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    stroke: "#373894",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.614 1.297h0a1.253 1.253 0 01.156 1.768h0a1.255 1.255 0 01-1.768.154h0a1.251 1.251 0 01-.154-1.768h0a1.249 1.249 0 011.766-.154zM18.374 11.173h0a1.253 1.253 0 01.154 1.768h0a1.253 1.253 0 01-1.768.154h0a1.253 1.253 0 01-.154-1.768h0a1.253 1.253 0 011.768-.154zM3.063 4.725h0a1.251 1.251 0 01.154 1.766h0a1.251 1.251 0 01-1.768.154h0a1.253 1.253 0 01-.154-1.766h0a1.251 1.251 0 011.768-.154zM6.477 11.935h0a1.255 1.255 0 01.154 1.768h0a1.253 1.253 0 01-1.768.154h0a1.251 1.251 0 01-.154-1.768h0a1.253 1.253 0 011.768-.154zM14.031 18.785h0a1.253 1.253 0 01.156 1.768h0a1.255 1.255 0 01-1.768.154h0a1.251 1.251 0 01-.154-1.768h0a1.249 1.249 0 011.766-.154z",
    fill: "#373894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.525 2.479L3.567 5.47l12.631 6.347-9.189 1.067 5.25 6.057",
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHowToGuide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/how_to_guide.f74ec74677d080c9325b83bc4ab89715.svg";